export default "__VITE_ASSET__DtuIsk9u__"